const getUtcOffsetLabel = (timeZone: string): string => {
  const now = new Date();
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    hourCycle: "h23",
  });

  const parts = formatter.formatToParts(now);
  const getPartValue = (type: Intl.DateTimeFormatPartTypes): number =>
    Number(parts.find((part) => part.type === type)?.value ?? "0");

  const year = getPartValue("year");
  const month = getPartValue("month");
  const day = getPartValue("day");
  const hour = getPartValue("hour");
  const minute = getPartValue("minute");
  const second = getPartValue("second");

  const zonedAsUtcMs = Date.UTC(year, month - 1, day, hour, minute, second);
  const offsetMinutes = Math.round((zonedAsUtcMs - now.getTime()) / 60000);

  const sign = offsetMinutes >= 0 ? "+" : "-";
  const absMinutes = Math.abs(offsetMinutes);
  const offsetHours = String(Math.floor(absMinutes / 60)).padStart(2, "0");
  const offsetRemainderMinutes = String(absMinutes % 60).padStart(2, "0");

  return `UTC${sign}${offsetHours}:${offsetRemainderMinutes}`;
};

const getConfigSystemValue = (key: string): string | undefined => {
  const configSystem = JSON.parse(localStorage.getItem("config_system") || "[]");
  return configSystem.find((config: { key: string; value: string }) => config.key === key)?.value;
};

const getStoredTimeZone = (): string => {
  return getConfigSystemValue("timezone") || Intl.DateTimeFormat().resolvedOptions().timeZone;
};

const getMinRequiredAge = (): number => {
  return Number(getConfigSystemValue("min_required_age")) || 18;
};

const getStoredCountryCode = (): string => {
  return getConfigSystemValue("country_code") || "";
};

export { getUtcOffsetLabel, getStoredTimeZone, getMinRequiredAge, getStoredCountryCode };
